import rightArrow from "@/assets/right-breadcrumb.svg";
import { FC } from "react";
import { Button } from "../Atoms";
import { DownloadIcon } from "@/assets";

type BreadcrumbProps = {
    name: string;
    onClickComplete: () => void;
    completeButtonEnabled?: boolean;
    isPdfGenerating?: boolean;
}

const Breadcrumb: FC<BreadcrumbProps> = ({ name, onClickComplete, completeButtonEnabled, isPdfGenerating }) => {
    return <div className="h-[36px] breadcrumb flex flex-row justify-between" >
        <div className="flex flex-row items-center">
            <span className="item-1">Triage</span>
            <img className="breadcrumb-arrow" alt="" src={rightArrow} />
            <span className="item-2 whitespace-nowrap">{name}</span>
        </div>
        <div className="complete-download-btn">
            <Button
                type={"tertiary"}
                stateProp={completeButtonEnabled ? "enabled" : "disabled"}
                suffixIcon={isPdfGenerating ? <span className="inline-block w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" /> : <DownloadIcon color={!completeButtonEnabled ? "#D6D5D4" : undefined} />
                }
                text={"Complete and download"}
                handleClick={onClickComplete}
                icon={false} 
            />
        </div>
    </div>
};

export default Breadcrumb;